import { Seo } from "@/components/layout/Seo";
import { Marquee } from "@/components/motion/Marquee";
import { Hero } from "@/components/home/Hero";
import { Reassurance, Presentation, ServicesPreview, Method, Commitments, FinalCta } from "@/components/home/Sections";
import { BeforeAfterPreview } from "@/components/home/BeforeAfter";
import { SITE } from "@/config/site";

const WEBSITE_LD = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  name: SITE.name,
  url: `${SITE.url}/`,
  inLanguage: "fr-FR",
};

export default function Home() {
  return (
    <>
      <Seo
        title="O'RIZON 360 — Rénovation et entretien d'immeubles à Nogent-sur-Marne (94)"
        description="Entreprise artisanale de rénovation et d'entretien d'immeubles en Île-de-France : maçonnerie, étanchéité, isolation, équipements techniques. Devis gratuit sous 48 h ouvrées."
        jsonLd={[WEBSITE_LD]}
      />
      <Hero />
      <Marquee items={["Maçonnerie", "Étanchéité", "Isolation", "Équipements techniques", "Rénovation complète", "Entretien & maintenance", "Nogent-sur-Marne", "Île-de-France", "Devis gratuit sous 48 h"]} />
      <Reassurance />
      <Presentation />
      <ServicesPreview />
      <Method />
      <Commitments />
      <BeforeAfterPreview />
      {/*
        AVIS CLIENTS — bloc volontairement désactivé.
        Ne pas inventer de témoignages. Lorsque de vrais avis seront disponibles (Google Business Profile,
        par exemple), créer un composant <Testimonials /> alimenté par ces avis réels et l'insérer ici.
        <Testimonials />
      */}
      <FinalCta />
    </>
  );
}
